import script from "./UiTable.vue?vue&type=script&setup=true&lang=js"
export * from "./UiTable.vue?vue&type=script&setup=true&lang=js"

import "./UiTable.vue?vue&type=style&index=0&id=6806ee68&lang=scss"

const __exports__ = script;

export default __exports__